export default __webpack_public_path__ + "static/media/bulldog-banner.c94d7486.png";